import React from 'react';
import Card from '@material-ui/core/Card';
const UssdItem = (props) => {
    // Declare a new state variable, which we'll call "count"
    // const percentState = number =>{
    //     let className= "";
    //     if(number > 0){
    //         className ="green-txt";
    //     }else if(number < 0){
    //         className ="red-txt";
    //     }
    //     return className;
    // }
    const {item} = props;
    return (
        <Card className="price-item uusd-item">
            
                <a href={`tel:${item.code}#`}>
                    <span className="ussd-name">{item.title}</span>
                    <i class="fa fa-phone"></i>
                </a>

        </Card>
    );
};
export default UssdItem;